// extracted by mini-css-extract-plugin
export var navbarSubLink = "N_g5 g_g5 g_gZ g_b6 g_dg g_fq g_cw g_cX";
export var menuLink = "N_wD g_gW g_fF";
export var subPageLink = "N_g8 g_g8";
export var burger = "N_wQ";
export var sublinkSize = "N_wR";
export var linkSize = "N_wS";
export var Link = "N_s1 y_s1 y_sl y_sG";